module.exports = __webpack_public_path__ + "static/media/IconDeleteAllFilters.046ff50e.svg";